export default __webpack_public_path__ + "static/media/dark-bottom.348902b1.webp";